import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TableWrapper, FullTable } from 'components';
import { CustomDeleteModal } from 'fragments';
import { AddResource } from './fragments';
import { RolePermission, PermissionsList, useModal, sortListByKey } from 'utils';
import { resourceActions } from 'store';
import { ACTION_TYPE, resourceBody, resourceHead, } from './constants';

const DELETE_RESOURCE = 'DELETE_RESOURCE';
export const Resource = () => {
  const resourceList = useSelector((state) => state.resource.resourceList);
  const dispatch = useDispatch();
  const history = useHistory();
  const info = history?.location?.state;
  const { open } = useModal();

  const renderParams = () => {
    const filteredInfo = {
      ...info,
    };
    filteredInfo.skip = info?.skip ? info?.skip : 0;
    filteredInfo.limit = 50;
    delete filteredInfo.page;
    delete filteredInfo.activeTab;
    delete filteredInfo.name;
    return filteredInfo;
  };
  const getResource = (load) => {
    dispatch(resourceActions.getResource(renderParams(), load));
  };

  useEffect(() => {
    getResource();
  }, [info]);

  const handleNavigate = (id) => {
    history.push(`/resource/${id}`);
  };

  const handleClickButton = (item, name) => {
    if (name === 'edit') {
      open(<AddResource info={item} closeToSuccess={() => getResource('noLoad')} />);
    }

    if (name === 'delete') {
      open(
        <CustomDeleteModal
              text="Are you sure you want to delete this folder? This action is not reversible."
              info="Folder"
              handleDel={() => dispatch(resourceActions.deleteResource(item?.id))}
              actionType={DELETE_RESOURCE}
              innerText={'Delete'}
              afterSuccess={() => getResource('noLoad')}
          />,
      );
    }
  };

  return (
    <TableWrapper
      tab={'none'}
      addButton={'Add Folder'}
      buttonsTab={true}
      buttonsTabAddButton={true}
      createPermisson={PermissionsList.MANAGE_RESOURCE}
      handleClick={() => open(<AddResource closeToSuccess={getResource} />)}
    >
      <FullTable
        head={resourceHead}
        body={resourceBody(renderParams())}
        loadingType={ACTION_TYPE}
        list={sortListByKey(resourceList?.resources, 'name', info)}
        listCount={resourceList?.count}
        handleClick={handleNavigate}
        handleClickButton={handleClickButton}
        noText={'Resource'}
        detailPage={(item) => `/resource/${item?.id}`}
      />
    </TableWrapper>
  );
};
